import React from 'react';
import DashboardLayout from '../components/DashboardLayout';

const ConnectingInformation: React.FC = () => {
  return (
    <DashboardLayout title="Connecting Information">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Connecting Information</h1>
        <p>This page will contain information about connecting and networking features.</p>
        {/* Add content here */}
      </div>
    </DashboardLayout>
  );
};

export default ConnectingInformation;